import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Table from '../../components/Table/Table'
import { requestsPMTableCols } from '../../helpers/tableUtils'
import FilterModal from '../../components/FilterModal/FilterModal'

const PlannedMaintenanceTable = ({
    data,
    onFilter,
    title,
    subtitle,
    isInCard,
    filtersToUse,
    ...otherProps
}) => {
    const [filterOpen, setFilterOpen] = useState(false)
    const [hasActiveFilters, setHasActiveFilters] = useState(false)

    const allFiltersIsReady = filtersToUse?.find(
        item => item?.filters?.length > 0 && item?.filterGrupName == 'Location',
    )

    useEffect(() => {
        if (filtersToUse) {
            const hasActive = filtersToUse.some(group =>
                group.filters?.some(filter => filter.checked),
            )
            setHasActiveFilters(hasActive)
        }
    }, [filtersToUse])

    return (
        <Table
            isInCard={isInCard}
            selectable={false}
            hasSearch={true}
            columns={requestsPMTableCols}
            data={data}
            totalResults={data?.length}
            type="scroll"
            headerTitle={title}
            headerSubtitle={subtitle}
            searchPlaceholder="Search PM"
            actions={[
                allFiltersIsReady && (
                    <FilterModal
                        isSmallScreen
                        key="filterModal"
                        filtersGroup={filtersToUse}
                        open={filterOpen}
                        setOpen={setFilterOpen}
                        onFilter={onFilter}
                        data={data}
                    />
                ),
            ]}
            searchFields={[
                'label',
                'showType',
                'status',
                'statusDescription',
                'assetNameNormalKey',
                'prettyDate',
                'shipToName',
                'address',
            ]}
            hasActiveFilters={hasActiveFilters}
            {...otherProps}
        />
    )
}

PlannedMaintenanceTable.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
    onFilter: PropTypes.oneOfType([PropTypes.func, PropTypes.any]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
    isInCard: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
    getAllRequests: PropTypes.bool,
    filtersToUse: PropTypes.array,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
}

export default PlannedMaintenanceTable
